export default "__VITE_ASSET__DjhOy2t___"